const Reflux = require('@muzzylane/reflux');
const ErrorConsts = require('../constants/error');
const ForgeError = require('../util/error');

var CaptchaActions = Reflux.createActions({
    "setScriptLoaded": {children: ["completed","failed"]}
});

CaptchaActions.setScriptLoaded.listen(function() {
    this.completed();
});

window.recaptchaOnLoad = function recaptchaOnLoad() { CaptchaActions.setScriptLoaded() }; // for callback in index.hbs recaptcha script tag

module.exports = CaptchaActions;
